import React from 'react'
import { filterNotificationsToBeDisplayed, hideNotification } from '../helpers'
import Confetti from '../../../components/Confetti'
import ProgramNotificationCard from './programNotificationCard'

export const navigateFromNotificationHandler = (btnLink,btnText,notificationId) => {
    hideNotification(notificationId);
    if(btnText === "Live Here") window.open(btnLink,"_blank")
    else window.location.assign(btnLink)
}

const BooksNotification = ({ writerNotificationsArr, updateWriterNotificationArr, ...props }) => {
    const closeWriterNotificationHandler = (id) => {
        hideNotification(id)
        updateWriterNotificationArr()
    }

    return (
        <>
            {!!filterNotificationsToBeDisplayed(writerNotificationsArr).length && (
                <Confetti particleCount={20}>
                {filterNotificationsToBeDisplayed(writerNotificationsArr).map(notification => (
                    <React.Fragment key={notification.id}>
                        <ProgramNotificationCard {...notification} actionBtnHandler={navigateFromNotificationHandler} closeBtnHandler={closeWriterNotificationHandler} />
                    </React.Fragment>))}
                </Confetti>
            )}
        </>
    )
}
export default BooksNotification
